/* eslint-disable react-hooks/exhaustive-deps */
// react
import { useEffect, useState } from "react"
import { Link, useHistory, useLocation } from "react-router-dom"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcSelector from "@grapecity/wijmo.grid.selector"

// other
import queryString from "query-string"
import Decimal from "decimal.js"
import dayjs from "dayjs"

// Kairos
import { AppDispatch } from "../../../.."
import AlertComponent from "../../../../components/AlertComponent"
import ComboBox from "../../../../components/ComboBox"
import MonthInput from "../../../../components/InputWrapper/MonthInput"
import { T社員マスタ } from "../../../../components/ComboBox/SyainComboBox"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
// import ConfirmModal from "../../components/ConfirmModal"
import DisplaySearchConditionLabel from "../../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../../components/Spinner"
import CONST from "../../../../constant"
import {
  clearAlert,
  setWarningAlerts,
  setAlerts,
} from "../../../../globalStore/alertStore"
import { TApiResponse } from "../../../../service/TApiResponse"

import {
  画面ロック解除,
  画面ロック開始,
} from "../../../../globalStore/progressStore"

import { RootState } from "../../../../globalStore/rootreducer"
import MakeInvoiceService from "../../../../service/billing/invoice/makeInvoiceService"
import {
  TInvoiceMakeListGetRes,
  TInvoiceMakeListGetReq,
  TInvoicePrintSeikyusyoReq,
  TInvoicePrintGoukeiSeikyusyoReq,
  TInvoiceSeikyuSimeCheckListGetRes,
  TInvoiceSeikyusyoCheckListGetRes,
  TInvoiceSeikyuSimePostReq,
} from "../../../../service/billing/invoice/TInvoice"
import { 区分分類コード } from "../../../../constant/enum/codes"
import { 請求_支払管理メニューコード } from "../../../../constant/menuCode"
import gridPageHelper from "../../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../../ts/helpers/pageHelper"
import util from "../../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../../type/wijmoComponents"
import MakeInvoiceExecModal from "./MakeInvoiceExecModal"
import MakeInvoicePrintModal from "./MakeInvoicePrintModal"
import {
  faFileAlt,
  faPlayCircle,
  faPlusSquare,
} from "@fortawesome/free-regular-svg-icons"
import KubunService from "../../../../service/master/kubun/kubunService"
import SyainService from "../../../../service/master/syain/syainService"
import { e請求書作成区分 } from "../../../../constant/enum/master"
import EmptyTextHeader from "../../../../components/FlexGridWrapper/EmptyTextHeader"
import TextInput from "../../../../components/InputWrapper/TextInput"

type TOmitDisplay =
  | "請求担当コード"
  | "締日区分コード"
  | "請求書作成区分コード"
  | "請求額確認区分コード"
  | "傭車会社あり対象フラグ"
  | "表示順区分コード"

type T表示用検索条件 = Omit<TInvoiceMakeListGetReq, TOmitDisplay> &
  Partial<{
    請求担当?: string
    締日区分?: string
    請求書作成区分?: string
  }>

type T荷主請求情報 = { 荷主コード: string; 表紙分割コード: string }
/**
 * 請求処理
 * @returns
 */
const MakeInvoice = () => {
  const history = useHistory()
  const location = useLocation()
  const { zengetuStr: 前月 } = useSelector((state: RootState) => state.date)
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "MakeInvoice_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        運送料: (item: TInvoiceMakeListGetRes) =>
          new Decimal(item.運送料課税額 ?? 0)
            .plus(item.運送料非課税額 ?? 0)
            .toNumber(),
        付帯料: (item: TInvoiceMakeListGetRes) =>
          new Decimal(item.付帯料課税額 ?? 0)
            .plus(item.付帯料非課税額 ?? 0)
            .toNumber(),
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    searchCondition?: TInvoiceMakeListGetReq,
    flg: boolean = false
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TInvoiceMakeListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new MakeInvoiceService().getList(currentSearchCondition)
      setPreSearchCondition(currentSearchCondition)
      // 検索結果をstateにセット
      res.data.forEach((row) => {
        if (row.請求伝票番号 == null || row.請求伝票番号 === "") {
          if (row.請求書作成区分コード === "2") {
            row.運送料課税額 = row.固定請求額合計
          }
        }
      })
      const gridCollectionView = createCollectionView(res.data, pageSize)

      if (isExecSime) {
        // 請求締め処理実行後の再検索時は元のページを表示する
        gridCollectionView.moveToPage(pageNumber)
      }
      setGridData({ data: gridCollectionView })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * 請求締め処理
   */
  const execSeikyuSime = async () => {
    // 請求締め処理の対象データを取得
    let inner選択荷主請求List: T荷主請求情報[] = []
    let inner対象荷主請求IDList: number[] = []
    let 対象締日区分コード: string = ""
    let isValid締日区分未設定: boolean = false
    let isValid締日区分混在: boolean = false
    let isValid請求処理状態区分: boolean = false
    let errMessage: string[] = []

    selectedRows?.forEach((row) => {
      let item: TInvoiceMakeListGetRes = row.dataItem

      inner対象荷主請求IDList.push(item.荷主請求ID)
      inner選択荷主請求List.push({
        荷主コード: item.荷主コード,
        表紙分割コード: item.表紙分割コード,
      })

      switch (item.締日区分コード) {
        case "20": // ２０日締め
          break
        case "25": // ２５日締め
          break
        case "99": // 月末日締め
          break
        default:
          isValid締日区分未設定 = true
      }
      if (対象締日区分コード === "") {
        対象締日区分コード = item.締日区分コード
      } else {
        if (item.締日区分コード !== 対象締日区分コード) {
          isValid締日区分混在 = true
        }
      }

      switch (item.請求処理状態区分コード) {
        case "2": // 確定
          isValid請求処理状態区分 = true
          break
        case "3": // 送付済
          isValid請求処理状態区分 = true
          break
        default:
          break
      }
    })

    if (isValid締日区分未設定) {
      errMessage.push("・締日区分が未設定の荷主が選択されています")
    }
    if (isValid締日区分混在) {
      errMessage.push("・締日区分が混在しています")
    }
    if (isValid請求処理状態区分) {
      errMessage.push(
        "・処理状態が「確定」または「送付済」の荷主は選択できません"
      )
    }

    if (errMessage.length > 0) {
      dispatch(setWarningAlerts(errMessage))
      return
    }

    const seikyuSimeCondition: TInvoiceSeikyuSimePostReq = {
      請求年月: 請求年月 ?? undefined,
      締日区分: 対象締日区分コード ?? undefined,
      荷主請求IdList: [...inner対象荷主請求IDList],
    }

    const service = new MakeInvoiceService()

    try {
      let res: TApiResponse<TInvoiceSeikyuSimeCheckListGetRes[]>
      res = await service.getCheckList(seikyuSimeCondition)
      if (res && res.data.length <= 0) {
        set選択荷主請求List(inner選択荷主請求List)
        set荷主請求IdList([...inner対象荷主請求IDList])
        setInner締日区分(対象締日区分コード)
        // 実行指示画面を表示
        setIsExecSime(false)
        setIsShow(true)
      } else {
        let msg: string[] = []
        msg.push("以下のデータの設定内容を確認してください")
        res.data.forEach((row) => {
          switch (row.区分コード) {
            case 0:
              msg.push(
                "・受注配車：" +
                  (row.受注伝票番号 ?? "") +
                  "-" +
                  (row.受注枝番 ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
            case 1:
              msg.push(
                "・荷主請求：" +
                  (row.荷主コード ?? "") +
                  "-" +
                  (row.表紙分割コード ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
            default:
              msg.push(
                "・荷主：" +
                  (row.荷主コード ?? "") +
                  "-" +
                  (row.表紙分割コード ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
          }
        })
        dispatch(setWarningAlerts(msg))
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  /**
   * 請求書印刷処理呼出し
   */
  const execPrintSeikyusyo = async () => {
    let printExceptCount = 0
    let inner対象荷主請求IDList: number[] = []
    let 対象締日区分コード: string = ""
    let isValid締日区分混在: boolean = false

    selectedRows?.forEach((row) => {
      let item: TInvoiceMakeListGetRes = row.dataItem

      if (item.請求伝票番号 == null) {
        printExceptCount += 1
      } else {
        if (対象締日区分コード === "") {
          対象締日区分コード = item.締日区分コード
        } else {
          if (item.締日区分コード !== 対象締日区分コード) {
            isValid締日区分混在 = true
          }
        }
      }
      inner対象荷主請求IDList.push(item.荷主請求ID)
    })

    if (printExceptCount > 0) {
      dispatch(setWarningAlerts(["請求データ未作成の荷主が選択されています"]))
      return
    }
    if (isValid締日区分混在) {
      dispatch(setWarningAlerts(["締日区分が混在しています"]))
      return
    }

    const seikyuSimeCondition: TInvoiceSeikyuSimePostReq = {
      請求年月: 請求年月 ?? undefined,
      締日区分: 対象締日区分コード ?? undefined,
      荷主請求IdList: [...inner対象荷主請求IDList],
    }
    const service = new MakeInvoiceService()

    try {
      //
      let simeRes: TApiResponse<TInvoiceSeikyuSimeCheckListGetRes[]>
      simeRes = await service.getCheckList(seikyuSimeCondition)
      if (!simeRes || simeRes.data.length > 0) {
        let msg: string[] = []
        msg.push("以下のデータの設定内容を確認してください")
        simeRes.data.forEach((row) => {
          switch (row.区分コード) {
            case 0:
              msg.push(
                "・受注配車：" +
                  (row.受注伝票番号 ?? "") +
                  "-" +
                  (row.受注枝番 ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
            case 1:
              msg.push(
                "・荷主請求：" +
                  (row.荷主コード ?? "") +
                  "-" +
                  (row.表紙分割コード ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
            default:
              msg.push(
                "・荷主：" +
                  (row.荷主コード ?? "") +
                  "-" +
                  (row.表紙分割コード ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
          }
        })
        dispatch(setWarningAlerts(msg))
        return
      }

      let printRes: TApiResponse<TInvoiceSeikyusyoCheckListGetRes[]>
      printRes = await service.getSeikyusyoCheckList(seikyuSimeCondition)
      if (!printRes || printRes.data.length > 0) {
        let msg: string[] = []
        msg.push(
          "以下の荷主は明細が修正されている可能性があります。再度、請求締め処理を実行してください"
        )
        printRes.data.forEach((row) => {
          msg.push("・" + (row.荷主名 ?? "") + (row.表紙名 ?? ""))
        })
        dispatch(setWarningAlerts(msg))
        return
      }
    } catch (error) {
      dispatch(setAlerts(error))
      return
    }

    // 印刷指示画面を表示
    setIsExecPrint(false)
    setIsShowPrint(true)
    set印刷設定_合計表題切替(0)
    set印刷設定_表題切替(0)
    set印刷設定_備考要否(0)
  }

  /**
   * 請求書印刷処理
   * @param printCondition 印刷条件
   */
  const printSeikyusyo = async (printCondition: TInvoicePrintSeikyusyoReq) => {
    setIsSearching(true) // 検索中状態に遷移

    try {
      const service = new MakeInvoiceService({ responseType: "blob" })
      let res

      if (printCondition.請求書印刷区分 === "1") {
        // 表紙／明細別
        res = await service.printSeikyusyo(printCondition)
      } else {
        // 表紙明細合体版
        res = await service.printSeikyusyoGattaiban(printCondition)
      }

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * 合計請求書印刷処理
   */
  const printGoukeiSeikyusyo = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    // 印刷条件の設定
    let 対象請求伝票番号: string[] = []

    selectedRows?.forEach((row) => {
      if (row.dataItem.請求伝票番号 != null) {
        対象請求伝票番号.push(row.dataItem.請求伝票番号)
      }
    })
    if (対象請求伝票番号.length <= 0) {
      setIsSearching(false) // 検索中状態に遷移
      dispatch(
        setWarningAlerts([
          "請求締め処理が行われていない荷主は合計請求書を作成できません",
        ])
      )
      return
    }
    const printCondition: TInvoicePrintGoukeiSeikyusyoReq = {
      抽出条件_請求伝票番号: 対象請求伝票番号,
    }

    try {
      const res = await new MakeInvoiceService({
        responseType: "blob",
      }).printGoukeiSeikyusyo(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TInvoiceMakeListGetReq = queryString.parse(location.search)
    set請求年月(query.請求年月)
    set請求担当コード(query.請求担当者コード)
    set締日区分(query.締日区分コード)
    set請求書作成区分コード(
      query.請求書作成区分コード === undefined
        ? null
        : query.請求書作成区分コード
    )
    set荷主コード(query.荷主コード)
    return query as TInvoiceMakeListGetReq
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TInvoiceMakeListGetReq => {
    return {
      請求年月: 請求年月 ?? undefined,
      請求担当者コード: 請求担当コード ?? undefined,
      締日区分コード: 締日区分 ?? undefined,
      請求書作成区分コード: 請求書作成区分コード ?? undefined,
      荷主コード: 荷主コード ?? undefined,
    }
  }

  /**
   * 印刷条件オブジェクトを生成
   */
  const createPrintCondition = (
    item: TInvoiceMakeListGetRes,
    指示_合同請求書表題: number,
    指示_表題切替: number,
    指示_備考要否: number,
    指示_頁不要: number
  ): TInvoicePrintSeikyusyoReq => {
    return {
      抽出条件_請求伝票番号: item.請求伝票番号 ?? undefined,
      明細ソート区分: item.明細ソート区分コード ?? undefined,
      請求書印刷区分: item.請求書印刷区分コード ?? undefined,
      合計表題切替: 指示_合同請求書表題,
      表題切替: 指示_表題切替,
      備考要否: 指示_備考要否,
      頁不要: 指示_頁不要,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TInvoiceMakeListGetReq
  ): T表示用検索条件 | undefined => {
    const disp年月 = dayjs(searchCondition.請求年月).format("YYYY/MM")
    return {
      請求年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      請求担当: 請求担当ItemSource?.find(
        (i) => i.社員コード === searchCondition.請求担当者コード
      )?.社員氏名,
      締日区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.締日区分コード &&
          i.分類コード === 区分分類コード.マスタ.締日区分
      )?.名称1,
      請求書作成区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.請求書作成区分コード &&
          i.分類コード === 区分分類コード.マスタ.請求書作成区分
      )?.名称1,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set請求年月(前月)
    set請求担当コード("")
    set締日区分("")
    setInner締日区分("")
    set請求書作成区分コード("")
  }

  /**
   * 請求書表紙複写作成処理
   */
  const copySeikyusyoHyosi = () => {
    dispatch(clearAlert()) // アラートを非表示に

    let selectedRowsCount = 0
    let hyosiNoMake = false
    let copyNoExec = false
    let seikyuGoukeiId = ""
    let errMessage: string[] = []

    selectedRows?.forEach((row) => {
      selectedRowsCount += 1
      if (row.dataItem.請求伝票番号 == null) {
        hyosiNoMake = true
      } else {
        seikyuGoukeiId = row.dataItem.請求合計ID
      }
      if (row.dataItem.請求書作成区分コード !== "3") {
        //「請求書作成区分：手作成」以外の場合
        copyNoExec = true
      }
    })

    if (selectedRowsCount !== 1) {
      errMessage.push("・複写元の荷主は１つだけ選択してください")
    }
    if (hyosiNoMake) {
      errMessage.push("・請求書表紙を作成していない荷主は選択できません")
    }
    if (copyNoExec) {
      errMessage.push("・「請求書作成区分：手作成」以外の荷主は選択できません")
    }

    if (errMessage.length > 0) {
      dispatch(setWarningAlerts(errMessage))
      return
    }

    // 請求書表紙編集画面へ遷移
    const url = util.getMenuPath(請求_支払管理メニューコード.請求書表紙)[2]
    history.push(url.replaceAll(":id", seikyuGoukeiId).replaceAll(":cp", "1"))
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    // 行頭選択
    new wjcSelector.Selector(grid, {
      itemChecked: () => {
        setSelectedRows([...grid.rows.filter((r) => r.isSelected)])
      },
    })
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [請求年月, set請求年月] = useState<string | null>()
  const [請求担当コード, set請求担当コード] = useState<string | null>()
  const [締日区分, set締日区分] = useState<string | null>()
  const [inner締日区分, setInner締日区分] = useState<string | null>()
  const [請求書作成区分コード, set請求書作成区分コード] = useState<
    string | null
  >(null)
  const [荷主請求IdList, set荷主請求IdList] = useState<number[]>([])

  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [荷主コード, set荷主コード] = useState<string>()

  const [preSearchCondition, setPreSearchCondition] =
    useState<TInvoiceMakeListGetReq>()
  //#region [comboboxState]
  // 締日区分
  const [締日区分ComboBox, set締日区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [締日区分IsLoadEnded, set締日区分IsLoadEnded] = useState<boolean>(false)
  // 請求書作成区分
  const [請求書作成区分ComboBox, set請求書作成区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [請求書作成区分IsLoadEnded, set請求書作成区分IsLoadEnded] =
    useState<boolean>(false)

  // 請求担当
  const [請求担当ComboBox, set請求担当ComboBox] = useState<TWijmoComboBox<
    string,
    T社員マスタ
  > | null>(null)
  const [請求担当IsLoadEnded, set請求担当IsLoadEnded] = useState<boolean>(false)
  const [請求担当ItemSource, set請求担当ItemSource] = useState<T社員マスタ[]>()

  // 処理実行モーダル
  const [isShow, setIsShow] = useState<boolean>(false)
  const [isExecSime, setIsExecSime] = useState<boolean>(false)
  const [isShowPrint, setIsShowPrint] = useState<boolean>(false)
  const [isExecPrint, setIsExecPrint] = useState<boolean>(false)

  // 請求書印刷設定
  const [印刷設定_合計表題切替, set印刷設定_合計表題切替] = useState<number>(0)
  const [印刷設定_表題切替, set印刷設定_表題切替] = useState<number>(0)
  const [印刷設定_備考要否, set印刷設定_備考要否] = useState<number>(0)
  const [印刷設定_頁不要, set印刷設定_頁不要] = useState<number>(0)
  const [selectedRows, setSelectedRows] = useState<wjGrid.Row[]>()
  const [選択荷主請求List, set選択荷主請求List] = useState<
    T荷主請求情報[] | null
  >()

  //#endregion

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    //TODO: API より取得
    Promise.all([
      new KubunService().getList(),
      new SyainService().getList({}),
    ]).then(([区分マスタRes, 請求担当Res]) => {
      set請求年月(前月)
      請求担当Res &&
        set請求担当ItemSource(
          請求担当Res.data.filter((i: T社員マスタ) => {
            return i.請求担当フラグ === 1
          })
        )
      区分マスタRes && set区分ItemSource([...区分マスタRes.data])
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (
      gridInitialized &&
      請求担当IsLoadEnded &&
      締日区分IsLoadEnded &&
      請求書作成区分IsLoadEnded
    ) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [
    gridInitialized,
    請求担当IsLoadEnded,
    締日区分IsLoadEnded,
    請求書作成区分IsLoadEnded,
  ])

  useEffect(() => {
    document.title = `請求処理`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    if (isExecSime) {
      // 請求締め処理実行後の再検索
      search(preSearchCondition).finally(() => {
        if (flexGrid) {
          flexGrid.rows.forEach((row) => {
            const dataItem: TInvoiceMakeListGetRes = row.dataItem
            if (
              選択荷主請求List?.find(
                (i) =>
                  i.荷主コード === dataItem.荷主コード &&
                  i.表紙分割コード === dataItem.表紙分割コード
              )
            ) {
              row.isSelected = true
            }
          })
          setSelectedRows([...flexGrid.rows.filter((r) => r.isSelected)])
        }
        flexGrid?.refresh()
        dispatch(画面ロック解除())
      })
    }
    setIsExecSime(false)
  }, [isExecSime])

  useEffect(() => {
    if (isExecPrint) {
      // 請求書印刷処理
      selectedRows?.forEach((row) => {
        let item: TInvoiceMakeListGetRes = row.dataItem

        // stateから印刷条件を生成
        let currentPrintCondition: TInvoicePrintSeikyusyoReq =
          createPrintCondition(
            item,
            印刷設定_合計表題切替,
            印刷設定_表題切替,
            印刷設定_備考要否,
            印刷設定_頁不要
          )

        if (item.請求書作成区分コード === "3") {
          //「請求書作成区分：手作成」の場合
          currentPrintCondition.請求書印刷区分 = "1"
        }
        printSeikyusyo(currentPrintCondition)
      })
    }
    setIsExecPrint(false)
  }, [isExecPrint])
  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">請求処理</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-60rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="w-8rem">
                                <MonthInput
                                  id="請求年月"
                                  value={請求年月}
                                  setValue={set請求年月}
                                  placeholder={"請求年月"}
                                />
                              </div>
                              <div className="w-15rem">
                                <ComboBox.Syain
                                  placeholder="請求担当"
                                  isAllSelect={true}
                                  itemsSource={請求担当ItemSource}
                                  isLoadEnded={請求担当IsLoadEnded}
                                  setIsLoadEnded={set請求担当IsLoadEnded}
                                  selectedValue={請求担当コード}
                                  setSelectedValue={set請求担当コード}
                                  ComboBox={請求担当ComboBox}
                                  setComboBox={
                                    set請求担当ComboBox
                                  }></ComboBox.Syain>
                              </div>
                              <div className="w-10rem">
                                <ComboBox.Kubun
                                  placeholder="締日"
                                  分類コード={区分分類コード.マスタ.締日区分}
                                  isLoadEnded={締日区分IsLoadEnded}
                                  setIsLoadEnded={set締日区分IsLoadEnded}
                                  isAllSelect={true}
                                  itemsSource={区分ItemSource}
                                  selectedValue={締日区分}
                                  setSelectedValue={set締日区分}
                                  ComboBox={締日区分ComboBox}
                                  setComboBox={
                                    set締日区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                              <div className="w-10rem">
                                <ComboBox.Kubun
                                  placeholder="請求書作成"
                                  分類コード={
                                    区分分類コード.マスタ.請求書作成区分
                                  }
                                  isLoadEnded={請求書作成区分IsLoadEnded}
                                  setIsLoadEnded={set請求書作成区分IsLoadEnded}
                                  isAllSelect={true}
                                  itemsSource={区分ItemSource}
                                  selectedValue={請求書作成区分コード}
                                  setSelectedValue={set請求書作成区分コード}
                                  ComboBox={請求書作成区分ComboBox}
                                  setComboBox={
                                    set請求書作成区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "6rem" }}
                                  id="荷主コード"
                                  name="荷主コード"
                                  value={荷主コード}
                                  setValue={(v) => {
                                    set荷主コード(v)
                                  }}
                                  maxLength={5}
                                  placeholder="荷主CD"
                                />
                              </div>
                            </div>
                            <div className="search-condition-row">
                              <Button
                                type="submit"
                                disabled={isSearching}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  e.preventDefault()
                                  // 検索実行時は行選択を消す
                                  setSelectedRows([])
                                  search()
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                                検索
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  gridProperties={{
                    headersVisibility: wjGrid.HeadersVisibility.All,
                  }}
                  headerComponent={
                    <>
                      <Button
                        disabled={
                          isSearching ||
                          selectedRows == null ||
                          selectedRows.length <= 0
                        }
                        onClick={() => {
                          dispatch(clearAlert())
                          execSeikyuSime()
                        }}>
                        <FontAwesomeIcon icon={faPlayCircle} />
                        締処理実行
                      </Button>
                      <Button
                        className="btn-done"
                        style={{ marginLeft: "1.5rem" }}
                        disabled={
                          isSearching ||
                          selectedRows == null ||
                          selectedRows.length <= 0
                        }
                        onClick={(e) => {
                          dispatch(clearAlert())
                          e.preventDefault()
                          e.stopPropagation()
                          execPrintSeikyusyo()
                        }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                        請求書印刷
                      </Button>
                      <Button
                        className="btn-done"
                        disabled={
                          isSearching ||
                          selectedRows == null ||
                          selectedRows.length <= 0
                        }
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          printGoukeiSeikyusyo()
                        }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                        合計請求書印刷
                      </Button>
                      <Link
                        style={{ marginLeft: "1.5rem" }}
                        to={
                          util.getMenuPath(
                            請求_支払管理メニューコード.請求書表紙
                          )[0]
                        }
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button className="w-8rem" disabled={isSearching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          表紙手作成
                        </Button>
                      </Link>
                      <Button
                        className="w-9rem"
                        disabled={
                          isSearching ||
                          selectedRows == null ||
                          selectedRows.length <= 0
                        }
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          copySeikyusyoHyosi()
                        }}>
                        <FontAwesomeIcon icon={faPlusSquare} />
                        表紙複写作成
                      </Button>
                    </>
                  }>
                  <wjrGrid.FlexGridColumn
                    allowDragging={false}
                    binding={"編集"}
                    hasFilter={false}
                    allowSorting={false}
                    align="center"
                    width={64}
                    selectable={false}
                    isReadOnly>
                    <EmptyTextHeader></EmptyTextHeader>

                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TInvoiceMakeListGetRes>
                      ) => {
                        // 表紙編集
                        const url = util.getMenuPath(
                          請求_支払管理メニューコード.請求書表紙
                        )[1]

                        // 締め処理未実施の荷主は編集はできない
                        if (context.item.請求合計ID == null) {
                          return <></>
                        }
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              dispatch(clearAlert())
                              if (context.item.請求合計ID == null) {
                                dispatch(
                                  setWarningAlerts([
                                    "請求データ未作成の荷主は編集できません",
                                  ])
                                )
                                return
                              }
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )
                              history.push(
                                url.replaceAll(
                                  ":id",
                                  context.item.請求合計ID.toString()
                                )
                              )
                            }}>
                            編集
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding={"明細"}
                    allowDragging={false}
                    hasFilter={false}
                    allowSorting={false}
                    align="center"
                    width={64}
                    selectable={false}
                    isReadOnly>
                    <EmptyTextHeader></EmptyTextHeader>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TInvoiceMakeListGetRes>
                      ) => {
                        // 請求明細一覧
                        const url = util.getMenuPath(
                          請求_支払管理メニューコード.請求明細一覧
                        )[0]
                        // 手作成は明細はない
                        // 締め処理未実施の荷主も明細は存在しない
                        if (
                          context.item.請求書作成区分コード ===
                            e請求書作成区分.手作成 ||
                          context.item.請求合計ID == null
                        ) {
                          return <></>
                        }
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              dispatch(clearAlert())
                              switch (context.item.請求書作成区分コード) {
                                case "1": // 受注配車
                                  break
                                case "2": // 月固定
                                  break
                                default:
                                  dispatch(
                                    setWarningAlerts([
                                      "「請求書作成区分：受注配車／月固定」の荷主のみ選択できます",
                                    ])
                                  )
                                  return
                              }
                              if (context.item.請求合計ID == null) {
                                dispatch(
                                  setWarningAlerts([
                                    "請求締め処理が未実施の荷主です",
                                  ])
                                )
                                return
                              }
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )
                              history.push(
                                url.replaceAll(
                                  ":id",
                                  context.item.請求合計ID.toString()
                                )
                              )
                            }}>
                            明細
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="荷主コード"
                    width={80}
                    header="荷主CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="荷主名"
                    width={250}
                    header="荷主名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="荷主略称"
                    width={160}
                    header="荷主略称"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求先部署"
                    width={160}
                    header="請求先部署"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求先担当者"
                    width={120}
                    header="請求先担当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="表紙分割コード"
                    width={80}
                    header="表紙CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="表紙名"
                    width={128}
                    header="表紙名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="締日区分名称"
                    width={80}
                    header="締日"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求書作成区分名称"
                    width={100}
                    header="請求書作成"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求担当者氏名"
                    width={128}
                    header="担当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求処理状態区分名称"
                    width={85}
                    header="処理状態"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求伝票番号"
                    width={120}
                    header="請求番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="案件数"
                    width={80}
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    header="案件数"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="運送料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={96}
                    header="運送料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="付帯料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={96}
                    header="付帯料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="高速料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={96}
                    header="高速料（税抜）"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="消費税"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={96}
                    header="消費税"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求合計額"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={110}
                    header="請求合計額"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <MakeInvoiceExecModal
        isShow={isShow}
        setIsShow={setIsShow}
        isExecSime={isExecSime}
        setIsExecSime={setIsExecSime}
        size={"sm"}
        title={"請求締め処理実行"}
        請求年月={請求年月}
        締日区分={inner締日区分}
        荷主請求IdList={荷主請求IdList}></MakeInvoiceExecModal>
      <MakeInvoicePrintModal
        isShow={isShowPrint}
        setIsShow={setIsShowPrint}
        isExecPrint={isExecPrint}
        setIsExecPrint={setIsExecPrint}
        size={"sm"}
        title={"請求書印刷処理実行"}
        合計表題切替={印刷設定_合計表題切替}
        set合計表題切替={set印刷設定_合計表題切替}
        表題切替={印刷設定_表題切替}
        set表題切替={set印刷設定_表題切替}
        備考要否={印刷設定_備考要否}
        set備考要否={set印刷設定_備考要否}
        頁不要={印刷設定_頁不要}
        set頁不要={set印刷設定_頁不要}></MakeInvoicePrintModal>
    </>
  )
}

export default MakeInvoice
